module.exports = __webpack_public_path__ + "img/logo.0b63af6f.png";